import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import Input from "~/components/Form/LandingInput"
import Spacer from "~/components/Spacer"
import FormError from "~/components/Form/ErrorText"
import Tooltip from "~/components/Tooltip"
import withTranslations from "~/components/_hocs/withTranslations"

import InputTitle from "./InputTitle"
import DropdownMenu from "../DropdownMenu"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
`

@inject((all) => ({
  validateDisplayMessage: all.store.trafficLookup.validateDisplayMessage,
  trafficTicketNumber: all.store.trafficLookup.trafficTicketNumber,
  changeTrafficTicketNumber: all.store.trafficLookup.changeTrafficTicketNumber,
}))
@observer
class TrafficTicketNumberInput extends Component {
  handleChange = (e) => {
    this.props.changeTrafficTicketNumber(e.target.value)
  }

  render() {
    const ticketErrorHandler = this.props.validateDisplayMessage(
      "trafficTicketNumber"
    )
    return (
      <Wrap>
        <InputTitle>
          {this.props.translate("label")}
          <Tooltip
            size={21}
            message={this.props.translate("tooltip")}
            icon="question"
          />
          <Spacer direction="width" mobile={11} desktop={11} />
          <DropdownMenu columnNumber="two" />
        </InputTitle>
        <Spacer desktop={16} mobile={4} />
        <Input
          placeholder="Ex: ABC1234567"
          value={this.props.trafficTicketNumber}
          onChange={this.handleChange}
          error={ticketErrorHandler}
        />
        <FormError error={ticketErrorHandler} />
      </Wrap>
    )
  }
}

export default withTranslations(
  TrafficTicketNumberInput,
  "form.traffic.ticketNumber"
)
